import styled from "styled-components";
import theme from "~/styles/theme";

export const BtnHolder = styled.div`
  width: 100%;

  button {
    width: 100%;
  }
`;

export const ModalContent = styled.div`
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 20px 40px;
  }
`;

export const Title = styled.div`
  color: var(--cores-0D5BA8, #0D5BA8);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%; /* 26.4px */
`;
